module.exports = __webpack_public_path__ + "assets/img/main-logo-cangzhou.56f9bd78.png";